// this file was copied from /marketing/resources. See the README in this directory for details

import * as React from 'react';

export const SvgIconChevronSmallDown = (props: React.ComponentPropsWithoutRef<'svg'>) =>
  React.createElement(
    'svg',
    { fontSize: '2.4rem', width: '1em', height: '1em', viewBox: '0 0 24 24', ...props },
    <path d="M7 8.5V11l5 5 5-5V8.5l-5 5-5-5z" fill="currentColor" />
  );
export default SvgIconChevronSmallDown;
